import { shallowEqual, useSelector } from 'react-redux'


export const useRequiresBankcardPanNumber = () => {
  const value: boolean = useSelector((state: any) => state.user.requires_bankcard_pan_number, shallowEqual)
  return value
}
